// extracted by mini-css-extract-plugin
export default {"title":"Tags__title___rPLN6","tagsWrapper":"Tags__tagsWrapper___y6FD_","clear":"Tags__clear___yUpne","tagArea":"Tags__tagArea___aiylO"};